 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AccountNotifications~Bid~CreateOrder~Expert~Profile~ProjectsArchive~ProjectsBidsNew~Quotation~Search~c2206087":"AccountNotifications~Bid~CreateOrder~Expert~Profile~ProjectsArchive~ProjectsBidsNew~Quotation~Search~c2206087","AccountNotifications~Bid~CreateOrder~Profile~ProjectsArchive~Quotation~SearchExpert~Ticket":"AccountNotifications~Bid~CreateOrder~Profile~ProjectsArchive~Quotation~SearchExpert~Ticket","AccountNotifications~Bid~CreateOrder~Profile~Quotation~Ticket":"AccountNotifications~Bid~CreateOrder~Profile~Quotation~Ticket","CreateOrder~Profile":"CreateOrder~Profile","CreateOrder":"CreateOrder","Profile":"Profile","AccountNotifications~Bid~ProjectsArchive~ProjectsBidsNew~Quotation~Ticket":"AccountNotifications~Bid~ProjectsArchive~ProjectsBidsNew~Quotation~Ticket","AccountNotifications":"AccountNotifications","Bid":"Bid","Quotation":"Quotation","Ticket":"Ticket","ProjectsArchive":"ProjectsArchive","SearchExpert":"SearchExpert","ProjectsBidsNew":"ProjectsBidsNew","Expert":"Expert","AccountRoot":"AccountRoot","Auth":"Auth","Confirmations":"Confirmations","Login":"Login","NotFound":"NotFound","Projects":"Projects","ProjectsBids":"ProjectsBids","Quotations":"Quotations","Registration":"Registration","RestorePassword":"RestorePassword","StripeConfirmations":"StripeConfirmations"}[chunkId]||chunkId) + "." + {"AccountNotifications~Bid~CreateOrder~Expert~Profile~ProjectsArchive~ProjectsBidsNew~Quotation~Search~c2206087":"d744423c","AccountNotifications~Bid~CreateOrder~Profile~ProjectsArchive~Quotation~SearchExpert~Ticket":"c0f0ee4c","AccountNotifications~Bid~CreateOrder~Profile~Quotation~Ticket":"36696345","CreateOrder~Profile":"a763f4da","CreateOrder":"e2987e05","Profile":"1a089463","AccountNotifications~Bid~ProjectsArchive~ProjectsBidsNew~Quotation~Ticket":"f5bd4194","AccountNotifications":"bb191b14","Bid":"5c0a4c6c","Quotation":"b2fc77bc","Ticket":"a3427f23","ProjectsArchive":"c6313d15","SearchExpert":"7566734c","ProjectsBidsNew":"0b680dab","Expert":"436d160c","AccountRoot":"10a544be","Auth":"6bc9c88e","Confirmations":"14f3e7da","Login":"e9b816d8","NotFound":"f234d96a","Projects":"78a2020d","ProjectsBids":"6b0be17f","Quotations":"104f95ee","Registration":"7e23523b","RestorePassword":"90ea3a87","StripeConfirmations":"27903514"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AccountNotifications~Bid~CreateOrder~Expert~Profile~ProjectsArchive~ProjectsBidsNew~Quotation~Search~c2206087":1,"AccountNotifications~Bid~CreateOrder~Profile~ProjectsArchive~Quotation~SearchExpert~Ticket":1,"AccountNotifications~Bid~CreateOrder~Profile~Quotation~Ticket":1,"CreateOrder~Profile":1,"CreateOrder":1,"Profile":1,"AccountNotifications":1,"Bid":1,"Quotation":1,"Ticket":1,"ProjectsArchive":1,"SearchExpert":1,"ProjectsBidsNew":1,"Expert":1,"Auth":1,"Confirmations":1,"Login":1,"Projects":1,"ProjectsBids":1,"Quotations":1,"Registration":1,"RestorePassword":1,"StripeConfirmations":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AccountNotifications~Bid~CreateOrder~Expert~Profile~ProjectsArchive~ProjectsBidsNew~Quotation~Search~c2206087":"AccountNotifications~Bid~CreateOrder~Expert~Profile~ProjectsArchive~ProjectsBidsNew~Quotation~Search~c2206087","AccountNotifications~Bid~CreateOrder~Profile~ProjectsArchive~Quotation~SearchExpert~Ticket":"AccountNotifications~Bid~CreateOrder~Profile~ProjectsArchive~Quotation~SearchExpert~Ticket","AccountNotifications~Bid~CreateOrder~Profile~Quotation~Ticket":"AccountNotifications~Bid~CreateOrder~Profile~Quotation~Ticket","CreateOrder~Profile":"CreateOrder~Profile","CreateOrder":"CreateOrder","Profile":"Profile","AccountNotifications~Bid~ProjectsArchive~ProjectsBidsNew~Quotation~Ticket":"AccountNotifications~Bid~ProjectsArchive~ProjectsBidsNew~Quotation~Ticket","AccountNotifications":"AccountNotifications","Bid":"Bid","Quotation":"Quotation","Ticket":"Ticket","ProjectsArchive":"ProjectsArchive","SearchExpert":"SearchExpert","ProjectsBidsNew":"ProjectsBidsNew","Expert":"Expert","AccountRoot":"AccountRoot","Auth":"Auth","Confirmations":"Confirmations","Login":"Login","NotFound":"NotFound","Projects":"Projects","ProjectsBids":"ProjectsBids","Quotations":"Quotations","Registration":"Registration","RestorePassword":"RestorePassword","StripeConfirmations":"StripeConfirmations"}[chunkId]||chunkId) + "." + {"AccountNotifications~Bid~CreateOrder~Expert~Profile~ProjectsArchive~ProjectsBidsNew~Quotation~Search~c2206087":"f7964ebf","AccountNotifications~Bid~CreateOrder~Profile~ProjectsArchive~Quotation~SearchExpert~Ticket":"9f096b30","AccountNotifications~Bid~CreateOrder~Profile~Quotation~Ticket":"8e63ab5c","CreateOrder~Profile":"fb562ca7","CreateOrder":"20da45d5","Profile":"d930d390","AccountNotifications~Bid~ProjectsArchive~ProjectsBidsNew~Quotation~Ticket":"31d6cfe0","AccountNotifications":"4fa9640c","Bid":"33995c10","Quotation":"badeb69f","Ticket":"be2e7147","ProjectsArchive":"7c67d7c9","SearchExpert":"670bb9e0","ProjectsBidsNew":"9dee95a6","Expert":"21a7e029","AccountRoot":"31d6cfe0","Auth":"84d54b42","Confirmations":"565eedbe","Login":"4ecf9be9","NotFound":"31d6cfe0","Projects":"1c78c376","ProjectsBids":"73cd828e","Quotations":"0f0b3e69","Registration":"da41a242","RestorePassword":"59c29e65","StripeConfirmations":"d6823c02"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
